import React from 'react';

/**
 * Standard ERP page chrome — one title hierarchy for every floorplan.
 */
const PageHeader = ({
  title,
  subtitle,
  eyebrow,
  actions,
  className = '',
  as: Root = 'header',
}) => {
  if (!title && !subtitle && !eyebrow && !actions) return null;

  return (
    <Root className={['ads-page-header', className].filter(Boolean).join(' ')}>
      <div className="ads-page-header__text">
        {eyebrow ? <p className="ads-page-header__eyebrow ads-type-micro">{eyebrow}</p> : null}
        {title ? <h1 className="ads-type-page-title">{title}</h1> : null}
        {subtitle ? <p className="ads-type-caption">{subtitle}</p> : null}
      </div>
      {actions ? <div className="ads-page-header__actions">{actions}</div> : null}
    </Root>
  );
};

export default PageHeader;
